import React, { useRef, useState } from "react";
import "./RecoveryCode.scss";
import { sendRecoveryPasswordCode } from "../../../redux/actions/recoveryPassword";
import { useHistory, useLocation } from "react-router";
import { useDispatch } from "react-redux";
import ConfirmPopUp from "../../global/ConfirmPopUp/ConfirmPopUp";
import BackButton from "../../global/BackButton/BackButton";

const DIGITS = 6;

const RecoveryCode = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const email = location.state?.email;
  const [code, setCode] = useState(new Array(DIGITS).fill(""));
  const [openPopUp, setOpenPopUp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const inputRefs = useRef([]);

  const focusAt = (index) => inputRefs.current[index]?.focus();

  const handleChange = (e, index) => {
    const val = e.target.value.replace(/\D/g, "").slice(-1);
    const newCode = [...code];
    newCode[index] = val;
    setCode(newCode);
    if (val && index < DIGITS - 1) focusAt(index + 1);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (code[index]) {
        const newCode = [...code];
        newCode[index] = "";
        setCode(newCode);
      } else if (index > 0) {
        focusAt(index - 1);
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      focusAt(index - 1);
    } else if (e.key === "ArrowRight" && index < DIGITS - 1) {
      focusAt(index + 1);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, DIGITS);
    if (!pasted) return;
    const newCode = new Array(DIGITS).fill("");
    pasted.split("").forEach((char, i) => { newCode[i] = char; });
    setCode(newCode);
    focusAt(Math.min(pasted.length, DIGITS - 1));
  };

  const handleResendEmail = () => {
    setIsLoading(true);
    dispatch(sendRecoveryPasswordCode({ email }))
      .then(() => {
        setOpenPopUp(true);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  const handleConfirm = () => {
    const urlCode = code.join("");
    if (urlCode.length === DIGITS) {
      history.push(`/recuperar-senha/codigo/${urlCode}`);
    } else {
      setErrorMessage("Preencha todos os campos com o código recebido.");
    }
  };

  return (
    <section className="RecoveryCode">
      <BackButton />
      <h2>Confirmar código</h2>
      <p className="rc-description">
        Insira o código de {DIGITS} dígitos que enviamos para seu e-mail.
      </p>

      <div className="rc-inputs" onPaste={handlePaste}>
        {code.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            className={`rc-input${digit ? " rc-input--filled" : ""}`}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onFocus={(e) => e.target.select()}
          />
        ))}
      </div>

      {errorMessage && <p className="rc-error">{errorMessage}</p>}

      <button
        className="rc-resend"
        onClick={handleResendEmail}
        disabled={isLoading}
        type="button"
      >
        {isLoading ? "Enviando..." : "Não recebi o código"}
      </button>

      <button className="rc-submit" onClick={handleConfirm} type="button">
        Confirmar
      </button>

      <ConfirmPopUp
        buttonAction={() => setOpenPopUp(false)}
        active={openPopUp}
        message="Código reenviado com sucesso. Em instantes você receberá um e-mail com o código. Verifique também a caixa de SPAM."
        buttonText="OK"
      />
    </section>
  );
};

export default RecoveryCode;
